import useLocalStorage from '../utils/useLocalStorage';

function useSignatureSettings() {
  const [sheetsPerSignature, setSheetsPerSignature] = useLocalStorage('sheetsPerSignature', 4);
  const [fillLastSignature, setFillLastSignature] = useLocalStorage('fillLastSignature', true);
  const [startPadding, setStartPadding] = useLocalStorage('startPadding', 0);
  const [endPadding, setEndPadding] = useLocalStorage('endPadding', 0);

  return {
    sheetsPerSignature, setSheetsPerSignature,
    fillLastSignature, setFillLastSignature,
    startPadding, setStartPadding,
    endPadding, setEndPadding,
  };
}

export default useSignatureSettings;
